module.exports = __webpack_public_path__ + "static/media/ntk1.9605cf1d.png";